import React, { Component } from "react";
import { Button, ModalDialog } from "@culturehq/components";

import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

class ErrorModal extends Component {
  constructor(props) {
    super(props);

    this.state = { open: !!props.error };
  }

  componentDidUpdate() {
    const { error } = this.props;
    const { open } = this.state;

    if (error && !open) {
      this.setState({ open: true });
    } else if (!error && open) {
      this.setState({ open: false });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });

    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { error } = this.props;
    const { open } = this.state;

    if (!open) {
      return null;
    }

    return (
      <ChqModalDialog className="error-modal">
        <ModalDialog.Body>
          {error && <ErrorMessage error={error} />}
          <Button fillParent onClick={this.handleClose}>
            <Trans>OK</Trans>
          </Button>
        </ModalDialog.Body>
      </ChqModalDialog>
    );
  }
}

export default ErrorModal;
